import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { isEmpty, isNil } from "lodash";

@Injectable()
export class CommonTokenStorage {

  public userDetailsSubject = new Subject<any>();

  constructor() { }

  get prefix(): string {
    if (window['prefix']) {
      return window['prefix'] + '_';
    } else {
      return '';
    }
  }

  /**
   * Get user in JSON string
   * @returns {Observable<any>}
   */
  public getUser() {
    const user = localStorage.getItem(this.prefix + 'user');
    return user;
  }

  /**
   * Set User
   * @returns {CommonTokenStorage}
   */
  public setUser(user: string): any {
    localStorage.setItem(this.prefix + 'user', user);

    return this;
  }

  public updateUserDetails(user) {
    let currentUser = JSON.parse(this.getUser());
    currentUser = { ...currentUser, ...user };
    this.setUser(JSON.stringify(currentUser));
    this.userDetailsSubject.next(currentUser);
  }

  /**
   * Get user in JSON string
   * @returns {Observable<any>}
   */
  public getLastLogin() {
    const user = localStorage.getItem(this.prefix + 'lastLogin');
    return user === 'null' ? null : user;
  }

  /**
   * Set User
   * @returns {CommonTokenStorage}
   */
  public setLastLogin(date: string): any {
    if (isNil(date) || isEmpty(date)) {
      localStorage.setItem(this.prefix + 'lastLogin', 'null');
    } else {
      localStorage.setItem(this.prefix + 'lastLogin', (Number(date) * 1000).toString());
    }
    return this;
  }
  /**
   * Get languages in JSON string
   * @returns {any}
   */
  public getLanguages(): any {
    const languages: any = localStorage.getItem(this.prefix + 'languages');
    try {
      return JSON.parse(languages);
    } catch (e) {
      return [];
    }
  }

  /**
   * Set languages
   * @returns {CommonTokenStorage}
   */
  public setLanguages(languages: string): any {
    localStorage.setItem(this.prefix + 'languages', languages);

    return this;
  }

  /**
   * Set current language
   * @returns {CommonTokenStorage}
   */
  public setCurrentLanguage(currentLang: string): any {
    localStorage.setItem(this.prefix + 'curLang', currentLang);
    return this;
  }

  /**
   * Get current language
   * @returns {any}
   */
  public getCurrentLanguage() {
    const currentLang: string = localStorage.getItem(this.prefix + 'curLang');
    return currentLang || 'en';
  }


    /**
   * Get configuration in JSON string
   * @returns {Observable<any>}
   */
    public getConfiguration(): Observable<any> {
      const configuration: any = localStorage.getItem(this.prefix + 'configuration');
      try {
        return of(JSON.parse(configuration));
      } catch (e) {
        return of(null);
      }
    }

  /**
   * Remove tokens
   */
  public clear() {
    localStorage.removeItem(this.prefix + 'lastLogin');
    localStorage.removeItem(this.prefix + 'user');
    localStorage.removeItem(this.prefix + 'languages');
  }
}
